function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.76056 1.80026C5.58756 1.30802 7.21584 0.603746 8.94997 1.32559C11.3211 2.3121 12.1649 4.26521 15.7611 1.6817C16.0694 1.46001 16.3107 1.57585 16.3107 1.95566V8.68701C16.3107 9.06682 16.1017 9.60097 15.8143 9.84914C15.1881 10.3902 14.0441 11.1952 12.817 11.1571C10.9773 11.0993 9.19505 9.14487 7.52759 9.14487C6.46303 9.14487 5.39885 9.66012 4.76846 10.0331C4.44154 10.2263 4.19336 10.1015 4.19336 9.72205V2.87512C4.19374 2.49562 4.43433 1.99447 4.76056 1.80026Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.69865 0C2.14144 0 1.68945 0.451988 1.68945 1.0092C1.68945 1.15221 1.71972 1.28796 1.7737 1.41031C1.86546 1.61899 2.01119 2.0524 2.01119 2.4319V17.3125C2.01119 17.692 2.31915 18 2.69865 18C3.07815 18 3.38611 17.692 3.38611 17.3125V2.4319C3.38611 2.0524 3.53185 1.61931 3.62329 1.41031C3.67726 1.28796 3.70753 1.15215 3.70753 1.0092C3.70785 0.452367 3.25618 0 2.69865 0Z"
});

function SvgBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/border.5bdc13db.svg";
export { ForwardRef as ReactComponent };